// ref: https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react-router-config/react-router-config-tests.tsx

import type { RouteConfig } from 'react-router-config';
import notFoundRoutes from 'routes/NotFound';

import App from './layout';

import homeRoutes from './Home';
import scaledMapRoutes from './ScaledMap';
import cityRoutes from './City';

const routes: RouteConfig[] = [
    {
        component: App,
        routes: [...homeRoutes, ...scaledMapRoutes, ...cityRoutes, ...notFoundRoutes],
    },
];

export default routes;
